module.exports = __webpack_public_path__ + "static/logo-eye-45410a96d2ddc983526abb3b8ee5e290.png";